<template>
  <div class="flow_detail">
    <van-sticky>
      <van-nav-bar title="流水详情" left-arrow @click-left="goback()" />
    </van-sticky>
    <!-- 写字楼卡片 -->
    <div class="detail_item">
      <div class="item_content">
        <div class="content_img">
          <van-image height="100%" width="100%" src="/static/images/index_bg.jpg" fit="cover" />
        </div>
        <div class="content_detail">
          <div class="fs16 line1">
            {{detail.siteVo.name}}
          </div>
          <div class="fs15 color666">{{detail.siteVo.district}}•{{detail.siteVo.address}}</div>
          <div class="detail_number">
            <div class="number">
              <div class="fs15">{{detail.siteVo.monthlyRent}}元/月</div>
              <div class="fs13 color666 m-l15">{{detail.siteVo.area}}㎡</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 表单 -->
    <van-form label-width="100" class="detail_form">
      <van-cell-group>
        <van-field input-align="right" :value="detail.orderNumber" label="订单号" placeholder="请输入" readonly />
        <van-field input-align="right" :value="detail.paymentNumber" label="支付编号" placeholder="请输入" readonly />
        <van-field input-align="right" :value="detail.totalPrice" label="订单价格" placeholder="请输入" readonly />
        <van-field input-align="right" :value="detail.discountAmount" label="优惠价格" placeholder="请输入" readonly />
        <van-field input-align="right" :value="detail.status_name" label="订单状态" placeholder="请输入" readonly />
        <van-field input-align="right" :value="detail.paymentTime" label="支付时间" placeholder="请输入" readonly />
      </van-cell-group>
    </van-form>
  </div>
</template>
<script>
import storage from "@/utils/storage";
import {
  Button,
  NavBar,
  Icon,
  Sticky,
  Image,
  Form,
  Field,
  CellGroup
} from "vant";
export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [Sticky.name]: Sticky,
    [Image.name]: Image,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup
  },
  data() {
    return {
      phone: "",
      sms: "",
      password: "",
      detail: {
        "id": 7,
        "orderNumber": "tgy202205100002",
        "user_id": 3,
        "user_telephone": "12345678902",
        "user_nickname": "会员002",
        "referee_user_id": 2,
        "referee_user_name": "会员001",
        "referee_user_cash": 300,
        "site_id": 24,
        "site_name": "中型办公室，带独立卫生间",
        "coupon_id": 0,
        "coupon_name": "",
        "contactName": "长大那",
        "contactNumber": "17807606331",
        "intermediary_company": "中山市软件科技有限公司",
        "company": "",
        "siteUse": "1",
        "siteUse_name": "仅租赁",
        "leaseDuration": 3,
        "leaseDuration_name": "3个月",
        "remark": "订单备注内容",
        "idCard": "",
        "idCard_front": "",
        "idCard_back": "",
        "businessLicense": "",
        "unifiedSocialCreditCode": "",
        "company_official": "",
        "company_legalPerson": "",
        "company_address": "",
        "else_registered": "0",
        "else_seal": "0",
        "else_bankAccount": "0",
        "else_taxBureauRegistration": "0",
        "else_annualAudit": "0",
        "else_accountOpeningAppointment": "0",
        "else_taxBureauDoorToDoorAppointment": "1",
        "totalPrice": 6000,
        "payablePrice": 6000,
        "discountAmount": 0,
        "paymentTime": "2022-05-15 13:06:22",
        "paymentMethod": "1",
        "paymentMethod_name": "微信",
        "paymentNumber": "DBZF202202159264",
        "contractSignTime": null,
        "contractExpirationTime": null,
        "status": "2",
        "status_name": "待接单",
        "webType": "2",
        "webType_name": "移动端",
        "createtime": "2022-05-10 15:39:50",
        "siteVo": {
            "id": 24,
            "site_supplier_id": 9,
            "site_supplier_name": "利和广场·万鼎商务中心",
            "name": "中型办公室，带独立卫生间",
            "area": "60",
            "monthlyRent": "2000",
            "province": "广东省",
            "city": "中山市",
            "district": "东区街道",
            "position": "利和广场",
            "address": "利和广场9层",
            "longitude": "113.378835",
            "latitude": "22.52522",
            "type": "2",
            "type_name": "二手房",
            "floor": "1",
            "floor_name": "第1层/合计50层",
            "level": "1",
            "level_name": "甲级",
            "register": "1",
            "register_name": "可注册",
            "utilizationRate": "80.00",
            "workstation": "10",
            "renovation": "1",
            "renovation_name": "精装修",
            "propertyFee": "",
            "siteCharacteristics": "1",
            "siteCharacteristics_name": "纯写字楼",
            "listingDetails": "场地情况",
            "paymentType_deposit": 1,
            "paymentType_payment": 2,
            "paymentType": "预付2个月，押金1个月",
            "rentFree_begin": 6,
            "rentFree_count": 0,
            "rentFree": "起租6个月/免租0个月",
            "leaseDuration": "6,12,24,36",
            "leaseDuration_name": "6个月,12个月,24个月,36个月",
            "contactName": "黄先生",
            "contactGender": "1",
            "contactGender_name": "男",
            "contactNumber": "17807606331",
            "broker_name": null,
            "broker_number": null,
            "broker_portrait": "/upload/user/portrait/default_portrait.png",
            "broker_qrcode": "",
            "shelfStatus": "1",
            "shelfStatus_name": "上架",
            "modifytime": "2022-04-30 03:15:34",
            "coverImageUrl": "http://120.78.220.143:8080/tgy/upload/site/20220430111534_4337.jpeg",
            "imageList": [
                {
                    "id": 78,
                    "name": "20220430111534_4337.jpeg",
                    "url": "http://120.78.220.143:8080/tgy/upload/site/20220430111534_4337.jpeg",
                    "thumbnailUrl": "",
                    "type": "0"
                },
                {
                    "id": 79,
                    "name": "20220430111534_4554.jpeg",
                    "url": "http://120.78.220.143:8080/tgy/upload/site/20220430111534_4554.jpeg",
                    "thumbnailUrl": "",
                    "type": "0"
                }
            ],
            "pdfList": [],
            "videoList": [
                {
                    "id": 80,
                    "name": "20220430111534_1909.mp4",
                    "url": "http://120.78.220.143:8080/tgy/upload/site/20220430111534_1909.mp4",
                    "thumbnailUrl": "",
                    "type": "2"
                }
            ],
            "fileIdList": [
                78,
                79,
                80
            ]
        },
        "contractImageList": []
    },
    };
  },
  mounted(){
    this.getDetail()
  },
  methods: {
    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    onsubmit() {
      this.$router.go(-1);
    },

    getDetail() {
      let that = this;
      that.$api.siteSupplierWithDrawDetailAPI({
        id: storage.getFlowId(),
      }).then(function(res) {
        if (res.data.code == 200) {
          that.detail = res.data.data
        } else {
          Notify({ type: "danger", message: '接口返回异常：' + res.data.message });
        }
      }).catch(function(err) {
        Notify({ type: "danger", message: JSON.stringify(err) });
      })
    },

  }
};

</script>
<style lang="less" scoped>
.flow_detail {

  // 写字楼卡片
  .detail_item {
    display: flex;
    flex-direction: column;
    padding: 0px 20px;
    border-bottom: 10px solid #f4f3f8;

    .item_content {
      display: flex;
      flex-direction: row;
      padding: 10px 0px;
      border-bottom: 1px solid #f1f1f1;

      .content_img {
        position: relative;
        width: 120px;
        height: 80px;
        border-radius: 2px;
        overflow: hidden;
      }

      .content_detail {
        width: 250px;
        display: flex;
        flex-flow: column; //垂直排列
        justify-content: space-between; //两端对齐
        margin-left: 10px;

        /deep/ .detail_tag {
          margin-right: 5px;

          .van-tag--plain {
            padding: 2px 3px;
          }
        }

        .detail_number {
          display: flex;
          justify-content: space-between;
          flex-direction: row;
          align-items: flex-end;

          .number {
            display: flex;
            flex-direction: row;
            align-items: flex-end;
          }
        }
      }
    }
  }

  .detail_form {
    border-bottom: 10px solid #f4f3f8;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/layout/place/flowDetail.vue